export const LA_RIOJA_MIN_SALUD_PALETTE = {
  primary: {
    main: '#E91A36',
    dark: '#E91A36',
  },
  secondary: {
    main: '#E91A36',
  },
}
